// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__MUF_x","info":"UpdateTermsInfo_info__3FLIk"};